export function isNotUndefined<T>(value: T | undefined): value is T {
  return value !== undefined;
}

export function isNotNull<T>(value: T | null): value is T {
  return value !== null;
}

export function isNotNullOrUndefined<T>(value: T | null | undefined): value is T {
  return isNotNull(value) && isNotUndefined(value);
}

export function isNonEmptyString<T>(value: T): value is T & string {
  return typeof value === 'string' && value.length > 0;
}
